// extracted by css-extract-rspack-plugin
export default {"DashboardGridContainer":"feX86","isFixedWidth":"fLouu","DashboardCardContainer":"X3_A9","Card":"xH0n9"};